import React from 'react'
import {createColumnHelper, IdentifiedColumnDef} from '@tanstack/react-table'
import {DatabaseMetadata} from 'graphql-api'
import {EmptyColumnDefType} from 'commonTypes'

import DatabaseIdCell from './cell/DatabaseId'
import RaveUrlCell from './cell/RaveUrl'
import DatabaseVersionCell from './cell/DatabaseVersion'
import AppVersionCell from './cell/AppVersion'
import ActiveCell from './cell/Active'
import EnabledCell from './cell/Enabled'
import StudyGroupUuidsCell from './cell/StudyGroupUuids'

// @ts-ignore
import {DataGridColumns} from '@mdsol/onex-design'

export type DatabaseColumnDefType = DatabaseMetadata | EmptyColumnDefType

const columnHelper = createColumnHelper<DatabaseColumnDefType>()

const columnsConfig: DataGridColumns[] = [
  columnHelper.accessor(
    'databaseId',
    {
      header: 'Database Id',
      textAlign: 'left',
      className: 'database-grid-cell database-id-cell',
      cell: props => <DatabaseIdCell {...props} />,
    } as IdentifiedColumnDef<DatabaseColumnDefType, any>
  ),
  columnHelper.accessor(
    'hostname',
    {
      header: 'Url',
      textAlign: 'left',
      className: 'database-grid-cell',
      cell: props => <RaveUrlCell {...props} />,
    } as IdentifiedColumnDef<DatabaseColumnDefType, any>
  ),
  columnHelper.accessor(
    'databaseVersion',
    {
      header: 'Database Version',
      textAlign: 'left',
      className: 'database-grid-cell',
      cell: props => <DatabaseVersionCell {...props} />,
    } as IdentifiedColumnDef<DatabaseColumnDefType, any>
  ),
  columnHelper.accessor(
    'appVersion',
    {
      header: 'App Version',
      textAlign: 'left',
      className: 'database-grid-cell',
      cell: props => <AppVersionCell {...props} />,
    } as IdentifiedColumnDef<DatabaseColumnDefType, any>
  ),
  columnHelper.accessor(
    'active',
    {
      header: 'Active',
      className: 'database-grid-cell',
      cell: props => <ActiveCell {...props} />,
    } as IdentifiedColumnDef<DatabaseColumnDefType, any>
  ),
  columnHelper.accessor(
    'enabled',
    {
      header: 'Enabled',
      className: 'database-grid-cell',
      cell: props => <EnabledCell {...props} />,
    } as IdentifiedColumnDef<DatabaseColumnDefType, any>
  ),
  columnHelper.accessor(
    'studyGroupUuids',
    {
      header: 'Study Group UUIDs',
      enableSorting: false,
      textAlign: 'left',
      className: 'database-grid-cell',
      cell: props => <StudyGroupUuidsCell {...props} />,
    } as IdentifiedColumnDef<DatabaseColumnDefType, any>
  ),
]

export default columnsConfig
